module.exports = __webpack_public_path__ + "media/images/rewards_gift-f4979b90.png";